import { CONFIG } from '../../core/config';
import { IColumn } from '../../viewmodels/runnableLookups/icell';
import { Unit } from '../../viewmodels/unit';
import { ViewModel } from '../view-model';
import { LookupCell } from './lookup-cell';
import { LookupColumnDataType } from './lookup-column-data-type';

export class LookupColumn implements ViewModel, IColumn {
  readonly friendlyTypeNameSingular = 'Lookup Column';
  readonly apiRoute: string = CONFIG.apiRoutes.lookupColumns;

  lookupColumnId: string;
  columnIndex: number;
  identifier: string;
  headerText: string;
  dataType: LookupColumnDataType;
  isDisplayColumn: boolean;
  unitOfMeasure: Unit;
  displayedUnitOfMeasure: Unit;
  uomName: string;
  displayedUomName: string;
  selectedRadioValue: string;

  cells: LookupCell[] = [];

  lookupId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.lookupColumnId = data.lookupColumnId;
    this.columnIndex = data.columnIndex;
    this.identifier = data.identifier;
    this.headerText = data.headerText;
    this.dataType = data.dataType;
    this.isDisplayColumn = data.isDisplayColumn;
    this.unitOfMeasure = new Unit();
    if (data.unitOfMeasure) {
      this.unitOfMeasure.loadFromJson(data.unitOfMeasure);
      this.uomName = this.unitOfMeasure.uomName;
    } else {
      this.uomName = '(none)';
    }
    this.displayedUnitOfMeasure = new Unit();
    if (data.displayedUnitOfMeasure) {
      this.displayedUnitOfMeasure.loadFromJson(data.displayedUnitOfMeasure);
      this.displayedUomName = this.displayedUnitOfMeasure.uomName;
    } else {
      this.displayedUomName = '(none)';
    }

    if (data.cells) {
      data.cells.forEach(cell => {
        const newCell = new LookupCell();
        newCell.loadFromJson(cell);
        this.cells.push(newCell);
      });
    }

    this.lookupId = data.lookupId;

    this.selectedRadioValue = data.selectedRadioValue;
  }
}
